import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import dayjs from 'dayjs';
import { getEventType, updateEvent, getEventsById, getEventStudent } from '@/app/services/events/events';
import { getAllRooms } from '@/app/services/rooms/rooms';
import PageHeader from '@/app/customComponents/PageHeader';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import EventForm from './EventForm';

const UpdateEvents = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { id } = useParams();

	const [isLoading, setIsLoading] = useState(true);
	const [types, setTypes] = useState([]);
	const [rooms, setRooms] = useState([]);
	const [initialForm, setInitialForm] = useState({
		id: null,
		date: null,
		student_id: null,
		room_id: [],
		type: '',
		custom_type: '',
		description: '',
	});
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		let mounted = true;
		getEventsById(id).then((res) => {
			if (!mounted) return;
			const ev = res.data;
			const eventRooms = JSON.parse(JSON.stringify(ev?.rooms || []));
			setInitialForm({
				id: ev?.id ?? null,
				date: ev?.datetime ? dayjs(ev.datetime) : null,
				student_id: ev?.students?.student_id || null,
				room_id: eventRooms,
				type: ev?.event_type?.id || '',
				custom_type: ev?.custom_type || '',
				description: ev?.description || '',
			});
			setIsLoading(false);
		});
		return () => {
			mounted = false;
		};
	}, [id]);

	useEffect(() => {
		let mounted = true;
		(async () => {
			const [typesRes, roomsRes] = await Promise.all([getEventType(), getAllRooms()]);
			if (!mounted) return;

			const prioritizedTypes = [
				...typesRes.data.filter((t) => t.id === 39),
				...typesRes.data.filter((t) => t.id !== 39).sort((a, b) => a.type.localeCompare(b.type)),
			];
			setTypes(prioritizedTypes);
			setRooms(roomsRes.data);
		})();
		return () => {
			mounted = false;
		};
	}, []);

	const handleGoBack = () => navigate(-1);
	const getStudentsPage = (page, selectedRooms) => getEventStudent(page, selectedRooms);

	const onSubmit = (payload) => {
		setIsSubmitting(true);
		updateEvent(payload, payload.id)
			.then(() => {
				dispatch(
					Actions.showMessage({
						message: 'Event Updated Successfully.',
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				navigate(-1);
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Update event.',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
			})
			.finally(() => setIsSubmitting(false));
	};

	return (
		<div className="overflow-auto mb-64 pb-64">
			<div className="w-11/12 mt-32 mx-auto mb-80">
				<PageHeader onBack={handleGoBack} title="Edit Event" />
				<div className="px-32 md:px-64 py-32 bg-white rounded-8 my-32">
					{isLoading ? (
						<div className="flex justify-center">
							<CircularProgress />
						</div>
					) : (
						<EventForm
							initialForm={initialForm}
							types={types}
							rooms={rooms}
							getStudentsPage={getStudentsPage}
							submitLabel="Update"
							onSubmit={onSubmit}
							onCancel={handleGoBack}
							isSubmitting={isSubmitting}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default UpdateEvents;
